import React from 'react';
import { ShieldCheck, Zap, Clock, Award, ThumbsUp, PenTool } from 'lucide-react';
import { Section } from '../ui/Section';
import { Card } from '../ui/Card';

export const Advantages = () => {
  const advantages = [
    {
      icon: ShieldCheck,
      title: 'Vrhunska Sigurnost',
      description: 'Sertifikovani sigurnosni sistemi i okovi koji garantuju bezbednost vašeg doma.'
    },
    {
      icon: Zap,
      title: 'Energetska Efikasnost',
      description: 'Značajna ušteda energije uz vrhunsku termoizolaciju naših profila.'
    },
    {
      icon: Clock,
      title: 'Dugotrajnost',
      description: 'Materijali otporni na sve vremenske uslove sa višegodišnjom garancijom.'
    },
    {
      icon: Award,
      title: 'Evropski Kvalitet',
      description: 'Koristimo isključivo proverene profile renomiranih evropskih proizvođača.'
    },
    {
      icon: ThumbsUp,
      title: 'Stručna Montaža',
      description: 'Naš tim sertifikovanih montera garantuje preciznu i čistu ugradnju.'
    },
    {
      icon: PenTool,
      title: 'Dizajn po Meri',
      description: 'Prilagođavamo se vašim željama i arhitektonskom stilu objekta.'
    }
  ];

  return (
    <Section>
      <div className="text-center max-w-3xl mx-auto mb-16">
        <h2 className="text-secondary font-bold uppercase tracking-widest mb-2 text-sm">Zašto Mi?</h2>
        <h3 className="text-3xl md:text-4xl font-bold mb-4 text-gray-900">
          Prednosti Naših <br />
          <span className="text-primary">Proizvoda i Usluga</span>
        </h3>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
        {advantages.map((adv, index) => (
          <Card key={index} className="p-8 text-center hover:border-primary/20">
            <div className="w-16 h-16 mx-auto bg-blue-50 rounded-full flex items-center justify-center mb-6 text-primary">
              <adv.icon size={32} />
            </div>
            <h4 className="text-xl font-bold mb-3 text-gray-900">{adv.title}</h4>
            <p className="text-gray-600 leading-relaxed">{adv.description}</p>
          </Card>
        ))}
      </div>
    </Section>
  );
};
